import React from 'react'
import Form from '../../components/Form'
import fields, { ResetFormData } from './fields'
import { handleFormSubmit, useRequest } from '@polvo-labs/react-auth'
import { toast } from 'react-toastify'

interface Props {
  token: string
  onSubmit: () => void
}

const ResetForm: React.FC<Props> = ({ token, onSubmit }) => {
  const { request } = useRequest()

  return (
    <Form<ResetFormData>
      buttonLabel="ENVIAR"
      fields={fields}
      onSubmit={data => handleFormSubmit({
        request: request({
          method: 'POST',
          url: `${process.env.REACT_APP_API_URL}/password/reset`,
          data: {
            ...data,
            token,
          },
        }),
        onFailure: (e: any) => toast.error('Ocorreu um erro na sua solicitação: ' + e.response.data.message),
        onSuccess: () => onSubmit(),
        onValidationErrors: (e: any) => () => toast.error('Ocorreu um erro na sua solicitação: ' + e.response.data.message),
      })}
    />
  )
}

export default ResetForm
